export default "__VITE_ASSET__tgFyw$X211zXSctfMU9_LA__ 220w, __VITE_ASSET__LphhLScmzwPqWwTyAbd7ig__ 325w";